export default {
    login: {
        method: 'post',
        url: 'managers/login'
    },
    loadSession: {
        method: 'get',
        url: 'managers/loadsession'
    },

    loginMember: {
        method: 'post',
        url: 'members/login'
    },
    loadSessionMember: {
        method: 'get',
        url: 'members/loadsession'
    }

}